import { ICitySatellite } from '@r1-frontend/api-domru/api-content/v1/geography/get-cities-satellites';
import { changeCity } from '@r1-frontend/entities/City/helpers/changeCity';

import { closeCitySelect } from '~/src/components/CitySelectContainer/store/actionCreators';
import { TAppThunkDispatch, TGetState } from '~/src/store';
import { setIsAuth } from '~/src/store/actionCreators/auth';
import selectProviderId from '~/src/store/selectors/selectProviderId';

const saveCity = (selectedCity?: ICitySatellite) => {
    return async(dispatch: TAppThunkDispatch, getState: TGetState): Promise<void> => {
        const state = getState();
        const { auth: { isAuth } } = state;
        const providerId = selectProviderId(state);

        if (selectedCity) {
            const { provider_id, has_sso } = selectedCity;
            if (provider_id !== providerId) {
                dispatch(setIsAuth(false));

                changeCity(provider_id, window.location.pathname, isAuth && !has_sso);
            }
        }

        dispatch(closeCitySelect());
    };
};

export default saveCity;
